import { IconType, JWayIcon } from "../../../assets/JWayIcons";
import styles from "./SectionTitle.module.scss";
export interface SectionTitleProps {
  children: React.ReactNode;
  iconType?: IconType;
  color?: string;
  iconSize?: number;
}

/**
 * Section title component
 * @param param0
 * @returns
 */
export default function SectionTitle({
  children,
  iconType,
  color = "#858585",
  iconSize = 15,
}: SectionTitleProps) {
  return (
    <div
      style={{
        color: color,
      }}
      className={[styles["container-title"]].join(" ")}
    >
      {iconType && (
        <div className={[styles["container-title__icon"]].join(" ")}>
          <JWayIcon type={iconType} size={iconSize} color={color} />
        </div>
      )}
      <h2 className={[styles["container-title__title"]].join(" ")}>
        {children}
      </h2>
    </div>
  );
}
